import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=3821467e&scoped=true&lang=pug"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=3821467e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3821467e",
  null
  
)

export default component.exports